/**
 * Extracts product identifiers needed for intent resolution from product data.
 *
 * @param {Object} product - The product object containing identifiers
 * @returns {Object} An object containing omsId and sku for intent resolution
 * @returns {string} returns.omsId - The OMS item ID from product identifiers
 * @returns {string} returns.sku - The SKU (storeSkuNumber, omsThdSku, or specialOrderSku)
 */
export const extractProductIdentifiersForIntent = (product) => {
  if (!product?.identifiers) {
    return { omsId: null, sku: null };
  }

  const { identifiers } = product;
  const omsId = identifiers.itemId;
  const sku = identifiers.storeSkuNumber || identifiers.omsThdSku || identifiers.specialOrderSku;

  return { omsId, sku };
};

/**
 * Resolves intents from items by mapping itemIds from intentItemMap to groupedMaterials.
 *
 * @param {Array} groupedMaterials - Array of group objects containing materials with intent information
 * @param {Object} intentItemMap - Map of intent identifiers to arrays of itemIds
 * @returns {Array} groupedMaterials with itemId added for matching intents
 */
export const resolveIntentFromItem = (groupedMaterials, intentItemMap) => {
  if (!groupedMaterials || !intentItemMap) {
    return groupedMaterials;
  }

  return groupedMaterials.map((group) => {
    let itemOrder = 0;
    const resolvedMaterials = group.materials?.flatMap((material) => {
      const intentKey = material.intent || material.intentId;
      const itemIds = intentItemMap[intentKey];

      if (itemIds?.length) {
        return itemIds.map((itemId) => {
          const currentOrder = itemOrder;
          itemOrder += 1;
          return { ...material, itemId, itemOrder: currentOrder };
        });
      }

      return material;
    });

    return { ...group, materials: resolvedMaterials || group.materials };
  });
};
